import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userData: {},
  isAuthenticated: false,
  loading: false,
  showFeedback: false,
};

const userSlice = createSlice({
  name: "counter",
  initialState,
  reducers: {
    setUserData: (state, action) => {
      state.userData = action.payload.userData;
    },
    setShowFeedback: (state, action) => {
      state.showFeedback = action.payload;
    },
  },
});

export const { setUserData, setShowFeedback } = userSlice.actions;

export default userSlice.reducer;
